import { render } from "./CometChatViewGroupMemberList.vue?vue&type=template&id=516393b4&scoped=true"
import script from "./CometChatViewGroupMemberList.vue?vue&type=script&lang=js"
export * from "./CometChatViewGroupMemberList.vue?vue&type=script&lang=js"

import "./CometChatViewGroupMemberList.vue?vue&type=style&index=0&id=516393b4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516393b4"]])

export default __exports__